<h2 mat-dialog-title>Ubah Profile</h2>
<mat-dialog-content class="mat-typography">

    <div class="pro-img text-center">
        <img [src]=" imgSrc" width="200" alt="user" class="img-circle">
        <input [formControl]="uploadFileForm" type="file" class="btn-primary" (change)="selectFile($event)"
            accept="image/*" />
    </div>

    <form class="form-container" name="form" (ngSubmit)="f.form.valid && save(ProfileSection.KONTAK_PRIBADI)"
        #f="ngForm" novalidate>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Alamat Domisili</mat-label>
                <input matInput type="text" [formControl]="addressForm" />
                <mat-error *ngIf="hpForm.invalid">{{
                    FormUtils.getErrorMessage(addressForm)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Nomor Handphone</mat-label>
                <input matInput type="text" [formControl]="hpForm" />
                <mat-error *ngIf="hpForm.invalid">{{
                    FormUtils.getErrorMessage(hpForm)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <!-- <p>
            <mat-form-field appearance="outline">
                <mat-label>No. Telp</mat-label>
                <input matInput type="text" [formControl]="noTelpForm" />
                <mat-error *ngIf="noTelpForm.invalid">{{
                    FormUtils.getErrorMessage(noTelpForm)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Email Dinas Pribadi</mat-label>
                <input matInput type="text" [formControl]="emailDinasForm" readonly />
                <mat-error *ngIf="emailDinasForm.invalid">{{
                    FormUtils.getErrorMessage(emailDinasForm)
                    }}</mat-error>
            </mat-form-field>
        </p> -->
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Email Pribadi</mat-label>
                <input matInput type="text" [formControl]="emailPribadiForm" />
                <mat-error *ngIf="emailPribadiForm.invalid">{{
                    FormUtils.getErrorMessage(emailPribadiForm)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </form>
    <div>
        <div class="text-center signature-container">
            <button *ngIf="!showSignature" mat-flat-button color="warn" (click)="editSignature()">
                Ubah Tanda Tangan
            </button>
            <img *ngIf="!showSignature" src="{{ tandaTangan }}" class="signature-image mt-2" />
            <button *ngIf="showSignature" mat-flat-button color="primary" (click)="saveSignature()">
                Simpan Tanda Tangan
            </button>
            <button *ngIf="showSignature" mat-flat-button color="warn" (click)="clearSignature()">
                Hapus Tanda Tangan
            </button>
            <signature-pad *ngIf="showSignature" style="background: #ffffff" class="mt-2" #signature
                [options]="signaturePadOptions"></signature-pad>
        </div>

        <div class="text-center mt-3">
            <mat-progress-bar *ngIf="isLoading" class="mt-1" mode="indeterminate"></mat-progress-bar>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Batal</button>
    <button mat-raised-button cdkFocusInitial color="primary" *ngIf="!isLoading" (click)="f.form.valid && onSubmit()">
        Simpan
    </button>
</mat-dialog-actions>